// app/javascript/packs/dropzone.js
import Dropzone from "dropzone";
import { DirectUpload } from "@rails/activestorage";

Dropzone.autoDiscover = false;

document.addEventListener("turbo:load", () => {
    const dropzoneElement = document.querySelector("#dropzone");
    const form = document.querySelector("#upload-form");

    if (!dropzoneElement || !form) return;

    const attachableType = form.dataset.attachableType;
    const attachableId = form.dataset.attachableId;

    const dropzone = new Dropzone(dropzoneElement, {
        url: "/rails/active_storage/direct_uploads",
        autoProcessQueue: false,
        addRemoveLinks: true,
        maxFilesize: 100,   // MB
        //acceptedFiles: "image/*,video/*,application/pdf", # Accept All File Type
        dictDefaultMessage: "",
        paramName: "file",
        init: function () {
            this.on("addedfile", file => {
                const upload = new DirectUpload(file, this.options.url);

                upload.create((error, blob) => {
                    if (error) {
                        console.error("Upload failed:", error);
                    } else {
                        const hidden = document.createElement("input");
                        hidden.type = "hidden";
                        hidden.name = "attachable[files][]";
                        hidden.value = blob.signed_id;
                        form.appendChild(hidden);
                    }
                });
            });
        }
    });
});
